// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { AbstractViewModel } from '@front/webmobile/ViewModels/AbstractViewModel';
import { AccountWidgetAccountDetailsPanelController } from '@shared/commons/AccountWidget/AccountWidgetAccountDetailsPanelController';
import { RowItemDataColorArray } from '@shared/commons/cache/VerticalPanel/AccountDetails/RowItemData';
export class AccountWidgetDragAndDropProps {
}
export class AccountWidgetDragAndDropComponentView {
}
export class AccountWidgetDragAndDropViewModel extends AbstractViewModel {
    get HeaderText() {
        return this.componentView.HeaderText;
    }
    set HeaderText(value) {
        this.updateComponentView('HeaderText', value);
    }
    get firstValue() {
        return this.componentView.firstValue;
    }
    set firstValue(value) {
        this.updateComponentView('firstValue', value);
    }
    get firstValueColor() {
        return this.componentView.firstValueColor;
    }
    set firstValueColor(value) {
        this.updateComponentView('firstValueColor', value);
    }
    get secondValue() {
        return this.componentView.secondValue;
    }
    set secondValue(value) {
        this.updateComponentView('secondValue', value);
    }
    get secondValueColor() {
        return this.componentView.secondValueColor;
    }
    set secondValueColor(value) {
        this.updateComponentView('secondValueColor', value);
    }
    get left() {
        return this.componentView.left;
    }
    set left(value) {
        this.updateComponentView('left', value);
    }
    get top() {
        return this.componentView.top;
    }
    set top(value) {
        this.updateComponentView('top', value);
    }
    constructor() {
        super(AccountWidgetDragAndDropComponentView);
        this.LEFTTOPOFFSET = 5;
        this.updatePosition = this.updatePosition.bind(this);
        this.setData = this.setData.bind(this);
    }
    initialize(props) {
        super.initialize(props);
        this.props = props;
        this.updateController(props.typePointer.GroupType);
        this.setData();
        this.props.subscribeOnUpdatePosition(this.updatePosition);
    }
    update(props) {
        var _a, _b;
        super.update(props);
        this.props = props;
        if (((_a = this.props.typePointer) === null || _a === void 0 ? void 0 : _a.GroupType) !== ((_b = props.typePointer) === null || _b === void 0 ? void 0 : _b.GroupType)) {
            this.updateController(props.typePointer.GroupType);
        }
        if (this.props.typePointer !== props.typePointer) {
            this.setData();
        }
    }
    dispose() {
        super.dispose();
        this.props.unsubscribeOnUpdatePosition(this.updatePosition);
    }
    setData() {
        const values = this.controller.getItemFormattedValue(this.props.typePointer.ItemType, this.props.typePointer.Key);
        const colors = this.getColor();
        this.HeaderText = this.controller.getItemName(this.props.typePointer.ItemType, this.props.typePointer.Key);
        this.firstValue = values.firstValue;
        this.firstValueColor = colors.firstValue;
        this.secondValue = values.secondValue;
        this.secondValueColor = colors.secondValue;
    }
    updatePosition(event) {
        const evt = event.event;
        this.MoveTo(evt.clientX + this.LEFTTOPOFFSET, evt.clientY + this.LEFTTOPOFFSET);
    }
    getColor() {
        const itemType = this.props.typePointer.ItemType;
        const itemKey = this.props.typePointer.Key;
        const controller = this.controller;
        const value = controller.getItemValue(itemType, itemKey);
        const strValue = controller.getItemFormattedValue(itemType, itemKey);
        if (strValue.isNAString()) {
            return new RowItemDataColorArray(null, controller.getColoringMethod(itemType));
        }
        return new RowItemDataColorArray(value, controller.getColoringMethod(itemType));
    }
    MoveTo(x, y) {
        this.left = x;
        this.top = y;
    }
    updateController(groupType) {
        this.controller = AccountWidgetAccountDetailsPanelController.getDataSource(groupType);
    }
}
